// Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';
import './login.css'; 
import Login from './Login';

const Unauthorized = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>403 - Unauthorized</h1>
      <p style={styles.message}>
        You do not have permission to access this page. Please Login to access this page.
      </p>
      <Link to='/login'style={styles.login}>Login</Link>
    </div>
  );
};

const styles = {
    login:{
textDecoration: 'none', 
    },
  container: {
    textAlign: 'center',
    padding: '50px',
    backgroundColor: '#f2f2f2',
    minHeight: '100vh',
  },
  heading: {
    color: '#d9534f',
    fontSize: '36px',
  },
  message: {
    fontSize: '20px',
    color: '#555',
  },
};

export default Unauthorized;
